import HomeIcon from "../assets/icons/home.svg";
import DashboardIcon from "../assets/icons/dashboard.svg";
import TermsIcon from "../assets/icons/more.svg";
import LogoutIcon from "../assets/icons/logout.svg";
import ProfileIcon from "../assets/icons/profile.svg";
import ChartIcon from "../assets/icons/chart.svg";
import SupportIcon from "../assets/icons/call.svg";
import medicalInstrumentIcon from "../assets/icons/medical-Instrument.svg";
import BlogIcon from "../assets/icons/blog.svg";

export const menuItems = [
  {
    title: "صفحه اصلی",
    icon: HomeIcon,
    link: "/",
    profile_related: false,
    is_admin: false,
  },
  {
    title: "داشبورد",
    icon: DashboardIcon,
    link: "/dashboard",
    profile_related: true,
    is_admin: true,
  },
  {
    title: "پروفایل کاربری",
    icon: ProfileIcon,
    link: "/profile",
    profile_related: true,
    is_admin: false,
  },
  {
    title: "سوابق آزمایش",
    icon: medicalInstrumentIcon,
    link: "/records",
    profile_related: true,
    is_admin: false,
  },
  {
    title: "منحنی بایوریتم",
    icon: ChartIcon,
    link: "/biorhythm",
    profile_related: false,
    is_admin: false,
  },
  {
    title: "پشتیبانی بادی‌بان",
    icon: SupportIcon,
    link: "/support",
    profile_related: false,
    is_admin: false,
  },
  {
    title: "مجله بادی‌بان",
    icon: BlogIcon,
    link: "https://bodybon.info/blog/",
    profile_related: false,
    is_admin: false,
    is_blank: true,
  },
  {
    title: "قوانین و مقررات",
    icon: TermsIcon,
    link: "/rules-and-regulations",
    profile_related: false,
    is_admin: false,
  },
  {
    title: "خروج",
    icon: LogoutIcon,
    link: "",
    profile_related: true,
    is_admin: false,
  },
];
